import { MouseEvent } from "react";
import * as d3 from "d3";

import { DatasetRecord, LineChartDataset } from "../LineChart";
import IChartCollision from "./IChartCollision";

export class PointCollision implements IChartCollision {
  private delaunay: d3.Delaunay<DatasetRecord>;
  private distanceMax: number;
  private mergedRecords: Array<DatasetRecord>;
  private xScale: d3.ScaleLinear<number, number>;
  private yScale: d3.ScaleLinear<number, number>;

  constructor(
    datasets: Array<LineChartDataset>,
    distanceMax: number,
    xScale: d3.ScaleLinear<number, number>,
    yScale: d3.ScaleLinear<number, number>
  ) {
    this.mergedRecords = datasets.reduce((all: Array<DatasetRecord>, curr: LineChartDataset) => {
      all = all.concat(curr.records);
      return all;
    }, []);

    this.distanceMax = distanceMax * distanceMax;
    this.xScale = xScale;
    this.yScale = yScale;

    this.delaunay = d3.Delaunay.from(
      this.mergedRecords,
      (d) => this.xScale(d._x ?? 0),
      (d) => this.yScale(d._y ?? 0)
    );
  }

  getCollision(event: MouseEvent<SVGRectElement>): Array<DatasetRecord> {
    const [pointerX, pointerY] = d3.pointer(event);
    const foundIndex = this.delaunay.find(pointerX, pointerY);
    const record = this.mergedRecords[foundIndex];
    const actualX = this.xScale(record._x ?? 0);
    const actualY = this.yScale(record._y ?? 0);
    const distance = Math.pow(actualX - pointerX, 2) + Math.pow(actualY - pointerY, 2);
    // The way this is done, collision distance is measured in px.
    if (distance <= this.distanceMax) {
      return [record];
    } else {
      return [];
    }
  }
}